











































import { mapActions, mapGetters } from 'vuex'
import OnsiteSearchGroupResultItem from './OnsiteSearchGroupResultItem.vue'
export default {
  components: { OnsiteSearchGroupResultItem },
    name: "OnsiteSearchGroup",
    props: {
        group: {
            type: Object
        }
    },
    computed: mapGetters(['getTranslations', 'getAllTabStatus']),
    methods: {
        getGroupResults() {
            this.$store.dispatch("getGroupContent", this.group.id)
            this.$store.dispatch("setSelectedTab", this.group.id)
            this.$emit('more-button-clicked', this.group.id);
        }
    }
}
